<template>
  <div class="day-select">
    <table>
      <tr v-for="row in totalRows" :key="'row'+row">
        <td v-for="col in totalCols" :key="'col'+row+col">
          <button class="single-day"
                  :class="{'active' : getOrdinal(row, col) === currentValue}"
                  @click.prevent="selectDay(getOrdinal(row, col))">
            {{ getOrdinal(row, col) }}
          </button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'day-select-grid',
  data () {
    return {
      selectedDay: null,
      totalRows: 3,
      totalCols: 7
    }
  },
  props: {
    value: [Number, String]
  },
  computed: {
    currentValue: {
      get () {
        return parseInt(this.$props.value)
      },
      set (val) {
        this.selectDay(val)
      }
    }
  },
  methods: {
    /**
     * Function that gets the number for a given coordinates in row x col matrix
     * The requirement was that numbers should start from 8, so we're offsetting it by 7
     * @param row { Number } y coordinate in matrix
     * @param col { Number } x coordinate in matrix
     * @returns {number} Number for speficied coordinates
     */
    getOrdinal (row, col) {
      return (row * col + ((row - 1) * (this.totalCols - col))) + 7 // 7 is start offset
    },
    /**
     * Selects a day and emits a value as we're binding our value to v-model
     * @param day
     */
    selectDay (day) {
      this.$emit('input', day)
    }
  }
}
</script>

<style scoped lang="scss">
.day-select {
  padding: 1rem;
  background-color: $white;
  border-radius: 5px;
  font-size: 1.5rem;

  table {
    width: 100%;

    td {
      text-align: center;
      padding: 0.4rem;
    }

    .single-day {
      font-weight: normal;
      color: $dark-grey;
      width: 2.6rem;
      height: 2.6rem;
      padding: 0;
      border-radius: 50px;

      &:hover {
        font-weight: bold;
        color: $text;
      }

      &.active {
        background-color: $primary;
        color: $white;
        font-weight: bold;

        &:hover {
          color: $white;
        }
      }
    }
  }
}
</style>
